module.exports = __webpack_public_path__ + "static/img/zhengxiaoyue.c68d62c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/touxiang/zhengxiaoyue.png
// module id = fLAg
// module chunks = 0